import { colors } from "../colors";

let locationPlotOptions = (theme) => ({
  chart: {
    type: "line",
    animation: false,
    backgroundColor: null,
    plotBackgroundColor: colors[theme].locationPlotBkg,
  },
  plotOptions: {
    line: {
      dataLabels: {
        enabled: true,
        allowOverlap: false,
        align: "center",
        style: {
          color: colors.chartAxisLabel,
          fontSize: "14px",
          fontWeight: "bold",
          textOutline: "0px contrast",
        },
      },
      enableMouseTracking: true, //determine tooltip apperance
    },
  },
  credits: {
    enabled: false,
  },
  boost: {
    enabled: false, // enable animation
    useGPUTranslations: true,
    seriesThreshold: 0,
  },
  colors: [
    // line colors
    colors.locationPlotLine1,
    colors.locationPlotLine2,
    colors.locationPlotLine3,
    colors.locationPlotLine4,
    colors.locationPlotLine5,
    colors.locationPlotLine6,
    colors.locationPlotLine7,
    colors.locationPlotLine8,
    colors.locationPlotLine9,
    colors.locationPlotLine10,
  ],
  title: {
    text: null,
    style: {
      color: colors.chartAxisLabel,
      fontSize: "15px",
    },
  },
  yAxis: {
    title: {
      text: "sws (m/s)",
      style: {
        color: colors.chartAxisLabel,
        fontSize: "14px",
      },
    },
    labels: {
      enabled: true,
      style: {
        color: colors.chartAxisLabel,
        fontSize: "12px",
      },
    },
    tickWidth: 1,
    tickColor: colors.locationPlotGridLine,
    gridLineWidth: 1,
    gridLineColor: colors.locationPlotGridLine,
  },
  xAxis: {
    categories: [],
    labels: {
      enabled: true,
      style: {
        color: colors.chartAxisLabel,
        fontSize: "12px",
      },
    },
  },
  legend: {
    layout: "vertical",
    align: "right",
    verticalAlign: "middle",
    useHTML: true,
    width: "20%",
    itemStyle: {
      color: colors.chartAxisLabel,
      fontSize: "12px",
    },
  },
  tooltip: {
    formatter: null,
    useHTML: true,
  },
  series: [],
});

export { locationPlotOptions };
